module.exports = __webpack_public_path__ + "img/select.e585d905.svg";